import { Pipe, PipeTransform } from '@angular/core';
/**
 *  @class SplitCurrencyPipe
 *  @desc Use this pipe to convert a number to currency, and return either the number before or after decimal point or both.
 *  @param {string | number} value the value to convert.
 *  @param {ReturnOptions} returnOptions wether to return value "before" or "after" decimal point should be returned, or "both"
 *
 *  @return {string} value formatted as a currency string, or the original value if it cannot be converted to a number.
 *
 *  @example
 *    {{ 4.23 | splitCurrency:"both" }} // output: 4,23
 */
type ReturnOptions = 'before' | 'after' | 'both';

@Pipe({
    name: 'splitCurrency',
    standalone: true,
})
export class SplitCurrencyPipe implements PipeTransform {
    public transform(value: string | number, returnOptions: ReturnOptions = 'both'): string {
        let val: number;
        if (typeof value === 'string') {
            if (isNaN(Number(value))) {
                return value;
            }
            val = Number(value);
        } else {
            val = value;
        }
        const before = Math.floor(val) + '';
        let after = Math.round((val % 1) * 100) + '';

        if (after.length < 2) {
            after = '0' + after;
        }
        switch (returnOptions) {
            case 'before':
                return before;
            case 'after':
                return after;
            case 'both':
            default:
                return before + ',' + after;
        }
    }
}
